import React from 'react';
import PropTypes from 'prop-types';

import { Table} from 'reactstrap';
import { OrderItem } from './OrderItem';
import { getClassNameOrderStatus } from 'helpers/order_helper';
import _ from 'lodash';

const numberFormat = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 });

function OrderSummary({ items }) {
    const user = JSON.parse(localStorage.getItem("authUser"))
    return (
        <>
            <div className="py-2 mt-3">
                <h3 className="font-size-14 fw-bold">Resumen de pedido</h3>
            </div>
            <div className="table-responsive">
                <Table className="table-nowrap">
                    <thead>
                        <tr>
                            <th style={{ width: "70px" }}>No.</th>
                            <th>Producto</th>
                            <th className="text-center">Peso Prom.</th>
                            <th className="text-end">Cantidad</th>
                            <th className="text-end">Precio unitario</th>
                            <th className="text-end">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            items.map(({ id, product, weight, weight_max, quantity, unit_price, unit_price_shipped, cost, total, total_cost, delivered }) => (
                                <OrderItem 
                                    key={ id }
                                    id={ id }
                                    peso={ (Number(weight) + Number(weight_max)) / 2 }
                                    product={ product }
                                    quantity={ quantity }
                                    unit_price={ user.user.type == 2 ? Number(cost) : (delivered == 1 ? Number(unit_price_shipped) : Number(unit_price)) }
                                    total={ user.user.type == 2 ? total_cost: total }
                                />
                            ))
                        }
                        <tr>
                            <th colSpan={5} className="text-right">Total Pedido</th>
                            <th className='text-right'>${numberFormat.format(_.sumBy(items, e => { return e.total;}))}</th>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </>
    )
}

OrderSummary.propTypes = {
    items: PropTypes.any
};

export default OrderSummary;
